module.exports = __webpack_public_path__ + "img/47_7.2c482463.png";